import { useEffect, useState } from "react";
import "../App.css";
import "../Backgrounds.css";
import "./Home.css";
import MainHeader from "../components/MainHeader";
import Footer from "../components/Footer";
import GeometricMap from "../components/GeometricMap";

const AITest = () => {
  const [selectedNode, setSelectedNode] = useState("hinterland");
  const [displayNode, setDisplayNode] = useState("hinterland");
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleNodeSelect = (nodeId) => {
    if (nodeId !== selectedNode) {
      // Fade out current gradient
      setIsVisible(false);

      // After fade out completes, change the gradient and fade in
      setTimeout(() => {
        setDisplayNode(nodeId);
        setSelectedNode(nodeId);
        setTimeout(() => {
          setIsVisible(true);
        }, 0);
      }, 300);
    }
  };

  return (
    <div>
      <div className="foreground">
        <MainHeader />

        <div className="homeBackground">
          <div className="geometricMapBackground">
            <div
              className={`geometricMapBackground-layer ${displayNode}`}
              style={{ opacity: isVisible ? 1 : 0 }}
            ></div>
          </div>

          <div className="homeContentContainer">
            <div className="block">
              <GeometricMap onNodeSelect={handleNodeSelect} />
            </div>

            <div className="solidLine"></div>

            <Footer />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AITest;
